(function () {

    a3_pilot_reports.directive('syllabusReadOnly', syllabusReadOnly);

       /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name syllabusReadOnly
   * @restrict E
   * @description
   *   Initialize read only view of submitted syllabus
   * @example
   *   Usage:
   *   <syllabus-read-only></syllabus-read-only>
   * @ngInject
   */

    function syllabusReadOnly() {
        function link(scope) {
            setSyllabus(scope.traineeSession);


            function setSyllabus(traineeSession) {

                var traineeSessionItems = [];
                scope.phase.Syllabus.SyllabusItems.forEach(function (item) {
                    var syllabusItem = JSON.parse(JSON.stringify(item));
                    syllabusItem.Tries = [];
                    syllabusItem.Selected = false;

                    var relatedSessionItem = null;
                    if(scope.type == "signature"){
                        relatedSessionItem = traineeSession.Items.find(x => x.Id == syllabusItem.Id);
                    }
                    else{
                        relatedSessionItem = traineeSession.Items.find(x => x.SyllabusItemId == syllabusItem.Id);
                    }

                    if(relatedSessionItem){
                        syllabusItem.Selected = true;
                        syllabusItem.Tries = relatedSessionItem.Tries;
                    }

                    if(scope.type == "signature"){
                        setPanelStyleByProgress(syllabusItem); 
                    }
                    else{
                        setPanelStyleBySelected(syllabusItem); 
                    }

                    
                    traineeSessionItems.push(syllabusItem);
                });

                traineeSession.ItemsGrouped = SyllabusGrouping(traineeSessionItems);

                traineeSession.ItemsGrouped.forEach(function(group){
                    group.Items.forEach(function(item){
                        //find first not ReadOnly try
                        item.firstTry = item.Tries.find(x => !x.isReadOnly);
                    });
                });
            }

            
            function setPanelStyleByProgress(item){
                var historyTriesCount = item.Tries.filter(x => x.isReadOnly).length;
                var newTriesCount = item.Tries.filter(x => !x.isReadOnly && x.Selected).length;
                item.TriesPerformedCount = historyTriesCount + newTriesCount;

                var completedItem = item.TriesPerformedCount >= item.MandatoryCount;

                if(item.MandatoryCount == 0){   //non-mandatory items are considered completed if performed at least once
                    completedItem = item.TriesPerformedCount>=1;
                }

                var nonCompetentItem = false;
                if (item.IsGradable && item.Selected) {
                    var gradingType = item.GradeType; //Numeric or Outcome or Competences
                    var traineeSelectedTries = item.Tries.filter(x => x.Selected);

                    traineeSelectedTries.forEach(function (selectedTry) {
                        if(!invalidItem && gradingType == "Outcome" && selectedTry.TryGrading.Grade == "Fail"){
                            nonCompetentItem = true;
                        }
                        
                    });
                }

                if(completedItem && !nonCompetentItem){
                    item.PanelClass = 'panel-green panel-border-left-green ';
                } else if(completedItem && nonCompetentItem){
                    item.PanelClass = 'panel-border-left-pink';
                }
                else{
                    item.PanelClass = 'panel-border-left-blue ';
                }
            }

            function setPanelStyleBySelected(item){
                var newTriesCount = item.Tries.filter(x => x.Selected).length;
                var selectedItem = newTriesCount>0;
              
                var nonCompetentItem = false;

                var completedItem = item.Tries.length >= item.MandatoryCount;
                if(item.MandatoryCount == 0){   //non-mandatory items are considered completed if performed at least once
                    completedItem = item.TriesPerformedCount>=1;
                }
                
                if (item.IsGradable && item.Selected) {
                    var outcomeType = item.GradeType == "Outcome";
                    var traineeSelectedTries = item.Tries.filter(x => x.Selected);

                    if(outcomeType){
                        traineeSelectedTries.forEach(function (selectedTry) {
                            if(outcomeType && selectedTry.TryGrading.Grade == "Fail"){
                                nonCompetentItem = true;
                            }                           
                        });
                    }                  
                }

                if(completedItem && selectedItem && !nonCompetentItem){
                    item.PanelClass = 'panel-green panel-border-left-green ';
                } else if(completedItem && selectedItem && nonCompetentItem){
                    item.PanelClass = 'panel-border-left-pink';
                }
                else{
                    item.PanelClass = 'panel-border-left-blue ';
                }
            }

            function SyllabusGrouping(items) {
                //Syllabus Items Group By 'GroupId'
                var syllabusGroups = [];
                items.forEach(function (item) {
                    if (!syllabusGroups.some(x => x.Id == item.SelectedGroup.Id)) {
                        if (!item.SelectedGroup) {
                            item.SelectedGroup = {
                                Id: 0,
                                Title: 'General'
                            };
                        }

                        var syllabusGroup = {
                            Id: item.SelectedGroup.Id,
                            Title: item.SelectedGroup.Title ? item.SelectedGroup.Title : 'General',
                            Items: []
                        };

                        syllabusGroup.Items.push(item);
                        syllabusGroups.push(syllabusGroup);
                    }
                    else {
                        syllabusGroups.filter(x => x.Id == item.SelectedGroup.Id)[0].Items.push(item);
                    }
                });

                return syllabusGroups;
            }

        }
        return {
            restrict: 'E',
            templateUrl: 'views/TrainingReadOnly/syllabus-read-only.tpl.html',
            scope : { phase:"=", traineeSession:"=", type:"="},
            terminal: true,
            link: link
        }
    }
})();